<template>
  <div>
    <b-modal id="userDataAddToMailerLiteModal" ref="userDataAddToMailerLiteModal" size="md" centered>
      <div slot="modal-header" class="w-100">
        <h5 class="modal-title float-left">
          {{$t('views.userdata.list.autoAddMailerLiteSubscriber')}}
        </h5>
        <button type="button" aria-label="Close" class="close" @click="hideModal('userDataAddToMailerLiteModal')">
          ×
        </button>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <b-alert show variant="info" class="m-0 mb-4">{{ $t('views.userdata.list.mailerLiteAddInfo') }}</b-alert>
          <Loader v-if="loadingMailerLiteGroups"></Loader>
          <div class="form-group col-sm-12" v-if="mailerLiteGroups.length > 0">
            <hr>
            <label>{{$t("views.userdata.list.mailerLiteAddToGroupInfo")}}:</label>
            <multi-select :selected-options="dataForm.mailerLiteGroupId"
                          :options="mailerLiteGroups"
                          name="mailerLiteGroupId"
                          @select="onGroupsSelect">
            </multi-select>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <div class="form-group col-sm-12">
          <div class="float-left">
            <a @click="store()" class="btn btn-success">{{ $t("buttons.submit") }}</a>
            <a class="btn btn-info" @click="hideModal('userDataAddToMailerLiteModal')">{{ $t("buttons.cancel") }}</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueForm from 'vue-form'
import { MultiSelect } from 'vue-search-select'
import ApiService from '@/utils/ApiService'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'userDataAddToMailerLiteModal',
  components: { Loader, MultiSelect },
  mixins: [VueForm],
  data () {
    return {
      display: false,
      loadingMailerLiteGroups: false,
      userData: '',
      dataFormReference: {},
      dataForm: {
        userDataId: [],
        mailerLiteGroupId: []
      },
      mailerLiteGroups: [],
      formstate: {}
    }
  },
  computed: {
    show () {
      return this.$store.state.modals.userdata.addToMailerLite.show
    }
  },
  watch: {
    show (newShow) {
      if (newShow > 0) {
        this.clearDataForm()
        this.dataForm.userDataId = this.$store.state.modals.userdata.addToMailerLite.selectedUsers
        this.$store.state.modals.userdata.addToMailerLite.show = 0
        this.showModal('userDataAddToMailerLiteModal')
        this.fetchMailerLiteGroups()
      }
    }
  },
  created () {
    this.makeReferenceObject()
  },
  methods: {
    makeReferenceObject () {
      this.dataFormReference = Object.assign({}, this.dataForm)
    },
    clearDataForm () {
      this.dataForm = Object.assign({}, this.dataFormReference)
    },
    async store () {
      let data = {}
      data.userDataId = this.dataForm.userDataId
      data.mailerLiteGroupId = this.dataForm.mailerLiteGroupId
      const response = await new ApiService('multiaddmailerlitesubscribers').post(data)
      if (response.status === 202) {
        this.$emit('fetchMailerLiteStatusData', 1)
        this.hideModal('userDataAddToMailerLiteModal')
      }
    },
    async fetchMailerLiteGroups () {
      this.loadingMailerLiteGroups = true
      this.mailerLiteGroups = []
      const response = await new ApiService('mailerlitegroups').getResults()
      this.mailerLiteGroups = response.map(entry => {
        return {
          value: entry.id,
          text: entry.name
        }
      })
      this.loadingMailerLiteGroups = false
    },
    onGroupsSelect (items, lastSelectItem) {
      this.dataForm.mailerLiteGroupId = items
      this.lastSelectItem = lastSelectItem
    },
    showModal () {
      this.$refs.userDataAddToMailerLiteModal.show()
    },
    hideModal () {
      this.$refs.userDataAddToMailerLiteModal.hide()
      this.clearDataForm()
    }
  }
}
</script>
